<template>
<span>
  <el-dialog
      :title="user_count + ' colleague(s) with tab open'"
      :visible.sync="showUserDetails">
    <ul>
    <li v-for="user in users">{{user.name}}</li>
  </ul>
  </el-dialog>

  <span v-if="got_data" @click="initiateShowUserDetails" slot="reference">{{user_count}} 👤</span>
</span>
</template>

<script>
export default {
  name: "Presence",
  props: ['extent_id'],
  mounted() {
    Echo.join("presence." + this.extent_id)
        .here((users) => {
          this.users = users
          this.user_count = users.length
          this.got_data = true
        })
        .joining((user) => {
          this.user_count++
          this.users.push(user)
          this.got_data = true
        })
        .leaving((user) => {
          this.user_count--
          this.users = this.users.filter(u => {
            return u.id !== user.id
          })
          this.got_data = true
        });
  },
  data() {
    return {
      user_count: 1,
      users: [],
      showUserDetails: false,
      got_data: false,
    }
  },
  methods: {
    initiateShowUserDetails() {
      this.showUserDetails = true
    }
  },
}
</script>

<style scoped>

</style>